import { FC, useEffect, useState } from 'react';
import { BrandButtonProps } from './types';
import { IoClose, IoRemove, IoTrash, IoTrashBinSharp, IoTrashSharp } from 'react-icons/io5';

const BrandButton2: FC<BrandButtonProps> = (props) => {
	const [isSelected, setIsSelected] = useState<boolean>(false);

	useEffect(() => {
		if (props.isSelected) {
			setIsSelected(true);
		} else {
			setIsSelected(false);
		}
	}, [props.isSelected]);

	return (
		<button
      className={`pop-brand-button2 pop-w-12 pop-h-12 pop-sm:pop-w-12 pop-sm:pop-h-12 ${isSelected ? 'selected' : ''} ${props.className ?? ''}`}
      onClick={props.onClick}
    >
      <div className="pop-flex pop-items-center pop-justify-center pop-w-full pop-h-full">
        {props.children}
      </div>

      {isSelected && props.onDelete && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            props.onDelete?.();
          }}
          className="pop-absolute pop-top--1 pop-right--1 pop-w-5 pop-h-5 pop-rounded-full pop-bg-white pop-border pop-flex pop-items-center pop-justify-center"
        >
          <IoClose size={12} fill="rgb(var(--pop-accent-red-90))"/>
        </div>
      )}
    </button>
	);
};

export default BrandButton2;
